import { Route, Switch } from 'react-router-dom';
import { DashboardWrapper } from '@/components/DashboardWrapper';
import { DataGenerationHistoryDrawer } from '@/components/DataGenerationHistory';
import { AdminsBar } from '../components/AdminsBar';
import { AppBar } from '../components/AppBar';
import ErrorBoundary from '../components/ErrorBoundary';
import { ResetPassword, SendResetLink } from '../components/ForgotPassword';
import ProtectedRoute from '../components/ProtectedRoute';
import UserConfirmation from '../components/UserConfirmation';
import { useAdminRoutes } from '../hooks/useAdminRoutes';
import { useProtectedRoutes } from '../hooks/useProtectedRoutes';
import Login from '../pages/Login';
import { OAuth2Login } from '../pages/OAuth2Login';
import SignUp from '../pages/SignUp';
import {
  CONFIRMATION_PATH,
  FORGOT_PASSWORD_PATH,
  OAUTH2_SIGN_IN_PATH,
  RESET_PASSWORD_PATH,
  SIGN_IN_PATH,
  SIGN_UP_PATH,
} from './constants';

export const getTestId = name => `${name}Page`;

export const ROUTES = [
  {
    path: SIGN_IN_PATH,
    Page: Login,
  },
  {
    path: OAUTH2_SIGN_IN_PATH,
    Page: OAuth2Login,
  },
  {
    path: SIGN_UP_PATH,
    Page: SignUp,
  },
  {
    path: CONFIRMATION_PATH,
    Page: UserConfirmation,
  },
  {
    path: FORGOT_PASSWORD_PATH,
    Page: SendResetLink,
  },
  {
    path: RESET_PASSWORD_PATH,
    Page: ResetPassword,
  },
];

export const AppRoutes = () => {
  const protectedRoutes = useProtectedRoutes();
  const adminRoutes = useAdminRoutes();

  return (
    <Switch>
      {ROUTES.map(({ path, Page }) => {
        return (
          <Route
            exact
            key={path}
            path={path}
            component={() => (
              <div data-testid={getTestId(Page.name)}>
                <Page />
              </div>
            )}
          />
        );
      })}
      {adminRoutes.map(({ path, Page, iframeSrc, exact }) => {
        return (
          <ProtectedRoute exact={exact} key={path} path={path}>
            <ErrorBoundary>
              <AdminsBar>
                <div data-testid={getTestId(Page.name)}>
                  <Page iframeSrc={iframeSrc} />
                </div>
              </AdminsBar>
            </ErrorBoundary>
          </ProtectedRoute>
        );
      })}
      {protectedRoutes.map(({ path, Page, forceNewTab }) => {
        return (
          <ProtectedRoute exact key={path} path={path}>
            <ErrorBoundary>
              <AppBar forceNewTab={forceNewTab} />
              <DashboardWrapper data-testid={getTestId(Page.name)}>
                <Page />
                <DataGenerationHistoryDrawer />
              </DashboardWrapper>
            </ErrorBoundary>
          </ProtectedRoute>
        );
      })}
    </Switch>
  );
};
